import { twMerge } from "tailwind-merge"
import { Select } from "../../../components/ui/Form/Select"
import { AgendaInteligenteController } from "../../../services/controllers/agendaInteligente"
import { useAgendaInteligente } from "../../../store/agendaInteligente/useAgendaInteligente"
import { CONTACT_STATUS_OPTIONS, DISABLED_STATUS_OPTIONS } from "../constants"

const CONTACT_CLASS = {
  confirmado: {
    root: '!border-[#10b981] [&_button]:!text-[#10b981] [&_button>span.open]:!text-[#10b981]',
    body: '!border-[#10b981]'
  },
  reagendado: {
    root: '!border-[#3b82f6] [&_button]:!text-[#3b82f6] [&_button>span.open]:!text-[#3b82f6]',
    body: '!border-[#3b82f6]'
  },
  sem_resposta: {
    root: '!border-[#8a3ba8] [&_button]:!text-[#8a3ba8] [&_button>span.open]:!text-[#8a3ba8]',
    body: '!border-[#d1d5db]'
  },
  pendente: {
    root: '!border-[#909397] [&_button]:!text-[#909397] [&_button>span.open]:!text-[#909397]',
    body: '!border-[#d1d5db]'
  },
}

const DISABLED_CLASS = {
  cancelado: 'text-[#ef4444]',
  finalizado: 'text-[#59602c]',
}

const OPTION_CLASS = {
  confirmado: "data-[state='checked']:!bg-[#10b981]  data-[state='checked']:!text-[#ecfdf5]",
  cancelado: "data-[state='checked']:!bg-[#ef4444]  data-[state='checked']:!text-[#fef2f2]",
  reagendado: "data-[state='checked']:!bg-[#3b82f6]  data-[state='checked']:!text-[#eff6ff]",
  sem_resposta: "data-[state='checked']:!bg-[#8a3ba8]  data-[state='checked']:!text-[#fff]",
  pendente: "data-[state='checked']:!bg-[#d1d5db]  data-[state='checked']:!text-[#555]",
  finalizado: "data-[state='checked']:!bg-[#59602c]  data-[state='checked']:!text-[#fff]",
}


export function ContactSelect({ appointment }) {
  const CAgendaInteligente = AgendaInteligenteController()
  const contactStatus = useAgendaInteligente(st => st.data.contactStatus)

  const appointmentStatus = contactStatus[appointment.appointmentId] || appointment.status

  if (_.keys(DISABLED_STATUS_OPTIONS).includes(appointmentStatus)) {
    return (
      <span
        className={twMerge('flex w-fit px-4 py-2 font-medium', DISABLED_CLASS[appointmentStatus])}>
        {DISABLED_STATUS_OPTIONS[appointmentStatus]}
      </span>
    )
  }


  return (
    <Select.Root
      value={appointmentStatus}
      style={{ maxWidth: "160px" }}
      className={CONTACT_CLASS[appointmentStatus].root}
      contentClass={CONTACT_CLASS[appointmentStatus].body}
      onChange={(status) => {
        CAgendaInteligente.setContactStatus(appointment.appointmentId, status)
      }}
    >
      {Object.entries(CONTACT_STATUS_OPTIONS).map(([key, value]) => (
        <Select.Option
          value={key}
          className={OPTION_CLASS[appointmentStatus]}
        >
          {value}
        </Select.Option>
      ))
      }
    </Select.Root >
  )
}
